<script setup>
import AppLayout from '@/Layouts/AppLayout.vue';

defineProps({
    status: Number,
    targetUrl: String,
})
</script>

<script>
export default {
    
    computed: {
        title() {
            return {
                503: 'Service Not Available',
                500: 'Internal Server Error',
                403: 'Access Denied',
                404: 'Page Not Found'
            }[this.status]
        },
        description() {
            return {
                503: "Sorry, we are operating a maintenance. Come back later.",
                500: 'Whoops, an error occured.',
                403: "Sorry, you are not allowed to access this content.",
                404: "Sorry, the page you are looking for does not exists."
            }[this.status]
        },
    },
    mounted(){
        if(this.status == 302 && this.targetUrl){
            this.$inertia.get(this.targetUrl);
        }
    }

}
</script>

<template>
    <AppLayout :title="title" desc="Discovers a wide range of properties in Dubai and UAE with Inspire Properties">
        <template #header>
            <!-- <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="#">Home</a></li>
                </ol>
            </nav> -->
            <div>
                <h1 class="head-status">{{ status }}</h1>
                <h2 class="page-header-heading">{{ title}}</h2>
                <p class="desc">{{ description }}</p>
                <div class="page-header-heading error-page">
                    <div>
                        <a class="btn-custom2" :href="route('index')">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M7 16l-4-4m0 0l4-4m-4 4h18" />
                            </svg>
                            <span class="py-2 px-4">Back To Home</span>
                        </a>
                        <div class="d-flex flex-wrap w-100 justify-content-start links">
                            <a :href="route('buy')" class="me-4">Buy</a>
                            <a :href="route('sell')" class="me-4">Sell</a>
                            <a :href="route('rent')" class="me-4">Rent</a>
                        </div>
                    </div>
                </div>
            </div>
        </template>

    </AppLayout>
</template>

<style>
    section.page-header{
        height: 860px;
        background: url("/images/error/background-image.jpg");
        background-repeat: no-repeat;
        background-size: cover;
    }
</style>

<style scoped>
    .btn-custom2{
        background-color: var(--secondary-color);
    }

    .btn-custom2 span{
        border-right: unset;
        border-left: 1px solid #172E4D;
    }

    .btn-custom2:hover span{
        border-left: 1px solid white;
    }

    .btn-custom2 svg{
        width: 72px;
        padding: 0.5rem 1.2rem;
    }

    .links a{
        text-decoration: none;
        color: white;
        font-size: 20px;
        margin-top: 5px;
    }

    .links a:hover{
        color: var(--secondary-color);
    }
    .desc{
        color: white;
        font-size: 1.1rem;
        z-index: 3;
        position: relative;
    }
    section.page-header .page-header-heading{
        font-size: 32px;
    }
    .head-status{
        position: relative;
        color: white;
        font-size: 80px;
        z-index: 3;
    }
</style>